export const day = {
  mon: {
    full: 'Senini',
    short: 'Sen'
  },

  tue: {
    full: 'Selasa',
    short: 'Sel'
  },

  wed: {
    full: 'Rabu',
    short: 'Ra'
  },

  thu: {
    full: 'Kamis',
    short: 'Kam'
  },

  fri: {
    full: 'Jumat',
    short: 'Jum'
  },

  sat: {
    full: 'Sabtu',
    short: 'Sab'
  },

  sun: {
    full: 'Minggu',
    short: 'Ming'
  }
};
